import { render, staticRenderFns } from "./RequestReplyDetailModal.vue?vue&type=template&id=49084122&lang=pug"
import script from "./RequestReplyDetailModal.vue?vue&type=script&lang=ts"
export * from "./RequestReplyDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports